<!-- Breadcrumb -->
<ol class="breadcrumb" *ngIf="breadcrumbInstituicao">
  <li class="breadcrumb-item">
    <a routerLink="">Home</a>
  </li>
  <li class="breadcrumb-item">Minha Conta</li>
  <li class="breadcrumb-item active">
    Instituições
  </li>
</ol>
<!-- //.Breadcrumb -->

<div *ngIf="instituicaoInconsitente && instituicaoInconsitente != ''" class="alert alert-danger col-12">
  {{instituicaoInconsitente}}
</div>
<!--inicio form-->

<form autocomplete="off" [formGroup]="instSelectForm">

  <div #instSelecionadas class="row" *ngIf="(instituicoesSelecionadas.length > 0) ? true : false">

    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <strong>Instituição(ões) Selecionada(s)</strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <table class="table table-striped" aria-describedby="Listagem Instituições cidadão">
                <thead>
                  <tr>
                    <th style="width: 60%">Nome Instituição</th>
                    <th>Área</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody *ngFor="let instituicao of instituicoesSelecionadas; let i = index">
                  <tr *ngIf="instituicao.codigoSituacaoInstituicao == 1">
                    <td>{{ instituicao.nome | uppercase }}</td>
                    <td *ngIf="instituicao.areaParticipacao != null">{{ instituicao.areaParticipacao | uppercase }}</td>
                    <td class="text-right">
                      <button type="button" (click)="onAlteraInstituicaoSelecionada(instituicao)" class="btn btn-bluelight"
                      data-toggle="tooltip" data-placement="top" title="Alterar">
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                      </button>

                      <button type="button" (click)="onRemoveInstituicaoSelecionada(i)" class="btn btn-danger" *ngIf="instituicoesSelecionadas.length > 1"
                          data-toggle="tooltip" data-placement="top" title="Excluir">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="instituicao.codigoSituacaoInstituicao == 2" style="background-color: rgba(255, 0, 0, 0.2);">
                    <td>{{ instituicao.nome | uppercase }}
                      <br>
                      <p class="instituicao-inativa-texto"><b>Instituição Inativa</b>: é possível substituir por outra da mesma área ou aguardar a regularização. Essa regularização depende exclusivamente de ações da instituição em sanar pendências cadastrais.</p>
                    </td>
                    <td *ngIf="instituicao.areaParticipacao != null">{{ instituicao.areaParticipacao | uppercase }}</td>
                    <td class="text-right">
                      <button type="button" (click)="onAlteraInstituicaoSelecionada(instituicao)" class="btn btn-bluelight"
                      data-toggle="tooltip" data-placement="top" title="Alterar">
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                      </button>

                      <button type="button" (click)="onRemoveInstituicaoSelecionada(i)" class="btn btn-danger" *ngIf="instituicoesSelecionadas.length > 1 || verificaInstituicoes(instituicoesSelecionadas)"
                          data-toggle="tooltip" data-placement="top" title="Excluir">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="mensagemSemestre && mensagemSemestre != ''" class="alert alert-danger col-12">
    {{mensagemSemestre}}
  </div>

  <hr *ngIf="(instituicoesSelecionadas.length < 2 || instituicaoIndexEdit !== null) ? true : false">

  <div class="row" *ngIf="(instituicoesSelecionadas.length < 2 || instituicaoIndexEdit !== null) ? true : false">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <strong>Indique Sua Instituição Favorita</strong>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <small>* Você poderá indicar no mínimo uma instituição e no máximo duas, sendo uma de cada área de atuação: Saúde e Social.</small>
            </div>
            <div class="col-sm-12">
              &nbsp;
            </div>
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-8">
                   <div class="form-group">
                    <label>Município</label>               
                    <ng-select [items]="listagemMunicipios$ | async"
                              bindLabel="nomeResumido"
                              [addTag]="false"
                              [multiple]="false"
                              [hideSelected]="false"
                              [clearSearchOnAdd]="true"
                              [loading]="Carregando"
                              placeholder="Pesquise o município desejado"
                              [typeahead]="municipioInput$"
                              notFoundText = "Não foram encontrados registros"
                              typeToSearchText = "Inicie a digitação"
                              [(ngModel)]="selectedMunicipio" 
                              [ngModelOptions]="{standalone: true}"
                              clearAllText = "Limpar"
                              (change)="PesquisarMunicipio()"
                              (clear)="LimparElementosBusca()"
                              (close)="LimparBuscasPreviasDeMunicipio()"
                              (keydown)="ControleTamanhoCampo($event, 50)">
                    </ng-select>
                   </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="areaParticipacao">Área</label>
                    <select name="areaParticipacao"
                            id="areaParticipacao"
                            class="form-control"
                            formControlName="areaParticipacao"
                            (change)="PesquisarArea()">
                        <option value="" selected>-- Selecione --</option>
                        <option *ngFor='let areaParticipacao of areasParticipacao; let i = index;'
                                [value]="areaParticipacao.id">
                          {{ areaParticipacao.nome }}
                        </option>
                    </select>
                  </div>
                </div>
                <!--row-->
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Nome Instituição</label>                  
                    <ng-select [items]="listagemInstituicoes$ | async"
                               bindLabel="nome"
                               [addTag]="false"
                               [multiple]="false"
                               [hideSelected]="false"
                               [clearSearchOnAdd]="true"
                               [loading]="Carregando"
                               placeholder="Pesquise a Instituicão desejada"
                               [typeahead]="instituicaoInput$"
                               notFoundText = "Não foram encontrados registros"
                               typeToSearchText = "Inicie a digitação"
                               [(ngModel)]="selectedInstituicao" 
                               [ngModelOptions]="{standalone: true}"
                               (change)="PesquisarInstituicao()"
                               clearAllText = "Limpar"
                               (clear)="LimparElementosBusca()"
                               (close)="LimparBuscasPreviasDeInstituicoes()"
                               (keydown)="ControleTamanhoCampo($event, 80)">
                    </ng-select>
                  </div>
                </div>
                <!--row-->
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <button
                      class="btn bg-transparent text-primary font-weight-normal RemoverButtonFocus" 
                      type="button"
                      aria-pressed="false"
                      [disabled]="(instituicoesSelecionadas.length >= 2 && instituicaoIndexEdit == null) ? true : false"
                      (click)="onSubmit()"
                      data-toggle="tooltip" data-placement="top" title="Exibe todas instituições de acordo com os critérios de preenchimento dos itens acima">(Exibir Instituições: Todas, Por Município, Por Área)</button>
                  </div>
                  <div *ngFor="let criterioBusca of mensagemCriteriosBusca">
                    {{ criterioBusca }}
                  </div>
                  <br/>
                  <div *ngFor="let error of formErrors.instituicaoNaoEncontrada" class="alert alert-danger col-sm-12">
                    {{ error }}
                  </div>
                </div>   
                <!--row-->
              </div>
              <div class="row" *ngIf="instituicoes">
                <div class="col-sm-12 text-right" *ngIf="instituicoes.length > 0">
                  <ngb-pagination
                    [collectionSize]="totalInstituicoes"
                    [(page)]="pagina"
                    [maxSize]="10"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    (pageChange)="pageChange($event)"
                  >
                  </ngb-pagination>
                </div>

                <div class="col-sm-12" *ngIf="instituicoes.length > 0">
                  <table class="table table-striped" aria-describedby="Listagem Instituições cidadão">
                    <thead>
                      <tr>
                        <th style="width: 5%">&nbsp;</th>
                        <th style="width: 60%">Nome Instituição</th>
                        <th>Endereço</th>
                        <th>Município</th>
                        <th>Área</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let instituicao of instituicoes; let i = index">
                        <td>
                          <input
                            type="radio"
                            name="codArea"
                            formControlName="codArea"
                            value="{{i}}"
                            >
                        </td>
                        <td>{{ instituicao.nome | uppercase }}</td>
                        <td>{{ instituicao.logradouro | uppercase }}</td>
                        <td>{{ instituicao.municipio | uppercase }}</td>
                        <td>{{ instituicao.areaParticipacao }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <br>
                </div>

                <div class="col-sm-12" *ngIf="instituicoes.length > 0">
                  <ngb-pagination
                    [collectionSize]="totalInstituicoes"
                    [(page)]="pagina"
                    [maxSize]="10"
                    [rotate]="true"
                    [ellipses]="false"
                    [boundaryLinks]="true"
                    (pageChange)="pageChange($event)"
                  >
                  </ngb-pagination>

                </div>

                <div *ngFor="let error of formErrors.errosSelecao" class="alert alert-danger col-sm-12">
                  {{ error }}
                </div>

                <div class="col-sm-12" *ngIf="instituicoes.length > 0">
                  <button class="btn btn-bluelight" (click)="onSelectInstituicao()"
                  data-toggle="tooltip" data-placement="top" title="Selecionar">Incluir</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--fim form-->
</form>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-instituicao/consumidor-instituicao.component.html